export const DobValidationMessageUat = {
  validationErrorMessage: 'workflow.consumerDob.validationErrorMessage'
}
